import type { DefaultRootState } from 'react-redux';

const isAppsumo = (state: DefaultRootState) => {
  return state.user.data[state.user.my?.login]?.isAppsumo || ['11', '12'].includes(state.subscription.state.plan);
};

export default isAppsumo;
